export function createId(prefix: string): string {
  return `${prefix}_${crypto.randomUUID()}`;
}

export function formatBytes(bytes: number): string {
  if (bytes < 1024) return `${bytes} B`;
  if (bytes < 1024 ** 2) return `${(bytes / 1024).toFixed(1)} KB`;
  return `${(bytes / 1024 ** 2).toFixed(1)} MB`;
}

export function formatRelativeTime(timestamp: number): string {
  const elapsed = Date.now() - timestamp;
  if (elapsed < 15_000) return "たった今";
  if (elapsed < 60_000) return `${Math.floor(elapsed / 1_000)}秒前`;
  if (elapsed < 3_600_000) return `${Math.floor(elapsed / 60_000)}分前`;
  return `${Math.floor(elapsed / 3_600_000)}時間前`;
}

